import EventCategory from './EventCategory';

export default EventCategory;
